//
//
//
//
//
//
//
//
import { colorUtils } from 'src/mixins/colors-utils';
export default {
  mixins: [colorUtils],
  props: {
    value: {
      type: String
    },
    size: {
      type: String,
      default: 'sm'
    },
    dense: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    localValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  }
};